// extracted by mini-css-extract-plugin
export default {"wrapper":"PGTpo6","loyalty-inner-text":"pRM35v","loyaltyInnerText":"pRM35v","second-line":"LYZz_I","secondLine":"LYZz_I"};